import React from "react";

const KidsSongsPage = () => {
  const lyrics = `ذهب الليل وطلع الفجر
والعصفور صوصو صوصو
شاف القطة قالت له نو نو
خاف العصفور وقال ميؤو`;

  const handleSpeak = () => {
    if (window.responsiveVoice) {
      window.responsiveVoice.speak(lyrics, "Arabic Male");
    }
  };

  return (
    <div className="p-6 bg-yellow-50 min-h-screen text-center">
      <h1 className="text-3xl font-bold mb-6 text-yellow-700">🎶 ذهب الليل</h1>
      <p className="text-lg whitespace-pre-wrap mb-4 text-gray-800">{lyrics}</p>
      <button
        onClick={handleSpeak}
        className="bg-yellow-300 hover:bg-yellow-400 px-4 py-2 rounded-full mb-6"
      >
        🔊 استمع
      </button>
      <div className="flex justify-center">
        <iframe
          width="560"
          height="315"
          src="https://www.youtube.com/embed/tXVaiOCMtZE"
          title="ذهب الليل"
          frameBorder="0"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
          allowFullScreen
        ></iframe>
      </div>
    </div>
  );
};

export default KidsSongsPage;
